import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

const { carbon } = colorsPalettes;

export const ContentFiltersHeader = () => {
    const { translate } = useTranslate();

    return (
        <Stack gap="8px">
            <Text
                fontVariant="subtitle1"
                color={carbon[500]}
            >
                {translate("activation.settings.news.section.title")}
            </Text>
            <Text
                fontVariant="body2"
                color={carbon[400]}
            >
                {translate("activation.settings.news.section.description")}
            </Text>
        </Stack>
    );
};
